import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import ResumeItem from '@/common/components/ResumeItem'
import { formatCnpj, formatPhoneNumber } from '@/common/utils/formatters'
import CreateForwardingDirectiveEntryFormStepHeader from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepHeader'
import { establishmentChoiceEntryOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/establishmentChoiceEntry/establishmentChoiceEntryOptions.constant'
import { MaintenanceForwardingsEstablishmentChoiceEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { Building2Icon } from 'lucide-react'
import { useParams } from 'react-router-dom'

const EstablishmentChoiceEntryManualEntryCompleted = () => {
  const { directiveEntryType } = useParams();

  const { selectedEstablishments } = useCreateForwardingsFormStore()

  const selectedEstablishment = selectedEstablishments[0]

  const manualEntryOption =
    establishmentChoiceEntryOptions[MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.ManualEntry]!

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        title={manualEntryOption.title}
        description={manualEntryOption.description(directiveEntryType)}
      />

      <div className="flex flex-col gap-2">
        <div>
          <div className="flex flex-col gap-3 bg-white-100 p-4 rounded-md">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <ImageWithPlaceholder placeholderIcon={Building2Icon} className="size-5" iconClassName="size-3" />

                <p className="text-sm font-bold">{selectedEstablishment.general_information?.fantasy_name}</p>
              </div>
            </div>

            <div className="flex flex-col gap-1">
              <p className="italic font-light text-sm">
                {selectedEstablishment.general_information?.address?.full || '--'}
              </p>
            </div>

            <div className="flex gap-3">
              <ResumeItem
                label="Telefone"
                value={
                  selectedEstablishment.general_information?.phone?.number
                    ? formatPhoneNumber(selectedEstablishment.general_information?.phone?.number)
                    : '--'
                }
                className="text-xs"
              />

              <ResumeItem
                label="Razão social"
                value={selectedEstablishment.general_information?.official_name || '--'}
                className="text-xs"
              />

              <ResumeItem
                label="CNPJ"
                value={
                  selectedEstablishment.general_information?.cnpj
                    ? formatCnpj(selectedEstablishment.general_information?.cnpj)
                    : '--'
                }
                className="text-xs"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EstablishmentChoiceEntryManualEntryCompleted
